import React, {useEffect, useState} from 'react';
import {BaseProps} from "../../../infrastructure/models/props/base-props";
import PerfectScrollbar from 'perfect-scrollbar';
import {useFallbackRef} from "../../../infrastructure/hooks/useFallbackRef";
import {useResizeDetector} from "react-resize-detector";
import './scroll-wrapper.scss';
import classnames from "classnames";
import styles from './scroll-wrapper.module.scss';
import {inject} from 'mobx-react';
import type {DeviceViewModel} from "../../models/device.view-model";

export class ScrollerWrapperProps extends BaseProps {
  children: React.Children;
  wheelPropagation: Boolean;
  device: DeviceViewModel;
}

export const ScrollerWrapper = inject('device')(React.forwardRef(({
                                                                    children,
                                                                    device,
                                                                    wheelPropagation,
                                                                    suppressScrollX,
                                                                    ...rest
                                                                  }: ScrollerWrapperProps, forwardedRef) => {
  const ref = useFallbackRef(forwardedRef);
  const [ps, setPs] = useState();
  const {ref: resizeRef, width, height} = useResizeDetector();

  useEffect(() => {
    let perfectScrollbar: PerfectScrollbar;
    if (!device.isSmallView) {
      if (ref.current) {
        perfectScrollbar = new PerfectScrollbar(ref.current, {
          wheelSpeed: 2, wheelPropagation: wheelPropagation || false, suppressScrollX :suppressScrollX, scrollXMarginOffset: 1, scrollYMarginOffset: 1
        });
      }

      setPs(perfectScrollbar);
    }

    return () => {
      perfectScrollbar?.destroy();
      setPs(null);
    }
  }, [device.isSmallView]);

  useEffect(() => {
    ps?.update();
  }, [width, height])

  const additionalProps = {
    ...rest,
  }

  return (device.isSmallView ? <div {...rest} ref={forwardedRef}>
    {children}
  </div> : <div ref={ref} {...additionalProps}>
    <div ref={resizeRef} className={classnames(styles.container)}>
      {children}
    </div>
  </div>)
}));
